import { render, staticRenderFns } from "./col-sctz39.vue?vue&type=template&id=a14409ce&scoped=true&"
import script from "./col-sctz39.vue?vue&type=script&lang=js&"
export * from "./col-sctz39.vue?vue&type=script&lang=js&"
import style0 from "./col-sctz39.vue?vue&type=style&index=0&id=a14409ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a14409ce",
  null
  
)

component.options.__file = "col-sctz39.vue"
export default component.exports